export function batchDocumentRoute(notification) {
  const batchId = notification.params?.batch_id;
  if (!batchId) return { name: 'admin-club-reimbursement-requests-batches-listing' };

  const documentId = notification.params?.document_id;
  const query = { tab: 'documents' };
  if (documentId) query.document_id = String(documentId);

  return {
    name: 'admin-club-reimbursement-requests-batch',
    params: { batch_id: batchId },
    query,
  };
}
